import { Button, Col, Space, Spin } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { Redirect, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useVideoConsultationRoom from './hooks/useVideoConsultationRoom';
import { ContentIframe } from '../../components/services-calendar/components/videoConsultation/styled';
import { videoConsultationParams } from '../../config/constants/videoConsultation';
import constants from '../../config/api/constants';

const DEFAULT_BACKGROUND_COLOR = '#333333';

const VideoConsultationRoom = () => {
  const { accountPrefix, username } = useParams();
  const { getVideoConsultationRoom, dataRoom, isLoading } = useVideoConsultationRoom();
  const location = window.location.href;
  const logoImgUrl = useMemo(() => {
    const selectedLogo = dataRoom?.accountData?.previewImg || dataRoom?.accountData?.menuLogoPlatform;
    return selectedLogo ? `${constants.s3Path}/${dataRoom.accountData.staticPrefix}/${selectedLogo}` : null;
  }, [dataRoom?.accountData?.staticPrefix, dataRoom?.accountData?.previewImg, dataRoom?.accountData?.menuLogoPlatform]);

  const iframeUrl = useMemo(() => {
    if (dataRoom == null) return null;
    const params = {
      background: 'off',
      logo: logoImgUrl ? 'off' : 'on',
    };
    if (dataRoom.params) {
      Object.entries(dataRoom.params).forEach(([key, value]) => {
        const videoConsultationParam = videoConsultationParams[key];
        if (videoConsultationParam == null) return;
        params[videoConsultationParam.param] = value ? videoConsultationParam.enable : videoConsultationParam.disable;
      });
    }
    const queryString = new URLSearchParams(params).toString();
    return `${dataRoom.roomUrl}?${queryString}`;
  }, [dataRoom?.params, dataRoom?.roomUrl, logoImgUrl]);

  useEffect(() => {
    const data = {
      accountPrefix,
      username,
    };
    getVideoConsultationRoom(data);
  }, []);

  if (isLoading) {
    return <Spin spinning={isLoading} />;
  }

  if (!dataRoom?.roomUrl) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Col xs={24}>
        <ContentIframe>
          <Col xs={24}>
            <Button type="link" style={{ color: 'black' }}>
              <Space>
                <span>
                  <LinkOutlined />
                </span>
                <span>{location}</span>
              </Space>
            </Button>
          </Col>
          <Col xs={24}>
            {logoImgUrl ? (
              <img
                src={logoImgUrl}
                alt="logo"
                style={{ maxHeight: 40, position: 'absolute', marginLeft: 8, marginTop: 8 }}
              />
            ) : null}
            <iframe
              title="videoconsultation-iframe"
              src={iframeUrl}
              allow="camera; microphone; fullscreen; speaker; display-capture"
              style={{
                width: '100%',
                height: '650px',
                border: 'none',
                background: dataRoom.accountVideoConsultationSettings?.backgroundColor || DEFAULT_BACKGROUND_COLOR,
              }}
            />
          </Col>
        </ContentIframe>
      </Col>
    </>
  );
};

export default VideoConsultationRoom;
